import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatMenuTrigger } from '@angular/material/menu'

export interface ACTIONS {
  icon: string
  actionName: string
  color?: string
  class?: string
  fn: any
}
import { CommonModule } from '@angular/common'
import { TranslatePipe } from '@ngx-translate/core'
import { MatMenuModule } from '@angular/material/menu'
import { MatButtonModule } from '@angular/material/button'

@Component({
  selector: 'app-actions-menu',
  templateUrl: './actions-menu.component.html',
  styleUrls: ['./actions-menu.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslatePipe, MatMenuModule, MatButtonModule]
})
export class ActionsMenuComponent {
  @Input() actions: ACTIONS[] = []
  @Input() row: any
  @Input() isDeleted: boolean = false
  @Output() openAction = new EventEmitter<any>()

  constructor() {}

  toggleMenu(menuTrigger: MatMenuTrigger): void {
    this.openAction.emit()
    menuTrigger.closeMenu()
    if (menuTrigger.menuOpen) {
      menuTrigger.closeMenu()
    } else {
      menuTrigger.openMenu()
    }
  }
}
